export default __webpack_public_path__ + "static/media/copy-white.e97b2669.svg";